export default "__VITE_ASSET__DLJbOgNk__"